export default "__VITE_ASSET__350e0d49__"